var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        height: "20px",
        width: "20px",
        version: "1.1",
        id: "Layer_1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        viewBox: "0 0 338.112 338.112",
        "xml:space": "preserve",
      },
    },
    [
      _c("g", [
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#333e48" },
            attrs: {
              d: "M304.836,173.589H164.48c-2.502,0-4.531-2.029-4.531-4.532c0-2.503,2.029-4.532,4.531-4.532\n\t\t\th140.356c2.504,0,4.533,2.029,4.533,4.532S307.339,173.589,304.836,173.589z",
            },
          }),
          _vm._v(" "),
          _c("circle", {
            staticStyle: { fill: "#61b4e4" },
            attrs: { cx: "304.836", cy: "169.057", r: "28.701" },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#333e48" },
            attrs: {
              d: "M164.48,173.589c-1.158,0-2.318-0.442-3.203-1.327c-1.771-1.77-1.771-4.64,0-6.41l99.246-99.246\n\t\t\tc1.77-1.77,4.641-1.77,6.408,0c1.771,1.77,1.771,4.64,0,6.41l-99.246,99.246C166.8,173.146,165.64,173.589,164.48,173.589z",
            },
          }),
          _vm._v(" "),
          _c("circle", {
            staticStyle: { fill: "#fee050" },
            attrs: { cx: "263.728", cy: "69.811", r: "21.981" },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#333e48" },
            attrs: {
              d: "M164.48,173.588c-2.502,0-4.531-2.029-4.531-4.532V28.701c0-2.503,2.029-4.532,4.533-4.532\n\t\t\ts4.533,2.029,4.533,4.532l-0.002,140.355C169.013,171.559,166.984,173.588,164.48,173.588z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#61b4e4" },
            attrs: {
              d: "M164.482,0c-15.852,0.001-28.701,12.85-28.701,28.701s12.85,28.701,28.699,28.701\n\t\t\tc15.854,0,28.701-12.85,28.701-28.702C193.181,12.85,180.332,0.001,164.482,0z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#333e48" },
            attrs: {
              d: "M164.48,173.588c-1.158,0-2.318-0.442-3.203-1.327L62.031,73.014c-1.771-1.77-1.771-4.64,0-6.41\n\t\t\tc1.768-1.77,4.641-1.77,6.408,0l99.246,99.247c1.771,1.77,1.771,4.64,0,6.41C166.8,173.146,165.64,173.588,164.48,173.588z",
            },
          }),
          _vm._v(" "),
          _c("circle", {
            staticStyle: { fill: "#fee050" },
            attrs: { cx: "65.235", cy: "69.809", r: "28.701" },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#333e48" },
            attrs: {
              d: "M164.48,173.588H24.125c-2.504,0-4.531-2.03-4.531-4.533s2.027-4.532,4.531-4.532l140.355,0.001\n\t\t\tc2.504,0,4.533,2.029,4.533,4.532S166.984,173.588,164.48,173.588z",
            },
          }),
          _vm._v(" "),
          _c("circle", {
            staticStyle: { fill: "#fb7598" },
            attrs: { cx: "24.125", cy: "169.054", r: "19.549" },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#333e48" },
            attrs: {
              d: "M65.232,272.834c-1.158,0-2.318-0.443-3.203-1.328c-1.771-1.77-1.771-4.64,0-6.41l99.248-99.246\n\t\t\tc1.768-1.77,4.641-1.77,6.408,0c1.771,1.77,1.771,4.64,0,6.41l-99.248,99.246C67.552,272.391,66.392,272.834,65.232,272.834z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#61b4e4" },
            attrs: {
              d: "M44.939,288.595c11.209,11.208,29.381,11.21,40.588,0.001c11.209-11.208,11.209-29.381,0.002-40.59\n\t\t\tc-11.211-11.208-29.383-11.208-40.59,0.001C33.732,259.216,33.732,277.388,44.939,288.595z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#333e48" },
            attrs: {
              d: "M164.48,313.944L164.48,313.944c-2.504,0-4.533-2.029-4.533-4.532l0.002-140.357\n\t\t\tc0-2.503,2.029-4.532,4.531-4.532l0,0c2.504,0,4.533,2.029,4.533,4.532l-0.002,140.357\n\t\t\tC169.011,311.915,166.982,313.944,164.48,313.944z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#005cb9" },
            attrs: {
              d: "M164.478,338.112c15.854-0.002,28.701-12.85,28.701-28.7c0-15.852-12.85-28.701-28.699-28.702\n\t\t\tc-15.852,0-28.701,12.85-28.701,28.702C135.779,325.262,148.63,338.111,164.478,338.112z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("g", [
          _c("path", {
            staticStyle: { fill: "#333e48" },
            attrs: {
              d: "M263.726,272.836c-1.16,0-2.32-0.442-3.205-1.327l-99.244-99.247c-1.771-1.77-1.771-4.64,0-6.41\n\t\t\tc1.768-1.77,4.641-1.77,6.408,0l99.246,99.248c1.77,1.77,1.77,4.64,0,6.41C266.046,272.393,264.885,272.836,263.726,272.836z",
            },
          }),
          _vm._v(" "),
          _c("path", {
            staticStyle: { fill: "#fb7598" },
            attrs: {
              d: "M284.021,288.599c11.207-11.211,11.209-29.381,0-40.589c-11.209-11.209-29.381-11.208-40.59-0.001\n\t\t\tc-11.207,11.208-11.209,29.381,0,40.59C254.64,299.806,272.812,299.804,284.021,288.599z",
            },
          }),
        ]),
        _vm._v(" "),
        _c("circle", {
          staticStyle: { fill: "#005cb9" },
          attrs: { cx: "164.481", cy: "169.057", r: "60.134" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }